{
  "hg19": [
    "/resources/tracks/hg19_annotations.json",
    "/resources/tracks/hg19_variants.json",
    "/resources/tracks/hg19_encode.json",
    "/resources/tracks/hg19_platinum_genomes.json",
    "/resources/tracks/hg19_tutorials.json"
  ],
  "hg38": [
    "/resources/tracks/hg38_annotations.json",
    "/resources/tracks/hg38_encode.json",
    "/resources/tracks/hg38_1KG_lowCoverageCrams.json"
  ],
  "mm10": [
    "/resources/tracks/mm10_annotations.json",
    "/resources/tracks/mm10_encode.json"
  ],
  "danRer11": [
    "/resources/tracks/danRer11_annotations.json"
  ],
  "danRer10": [
    "/resources/tracks/danRer10_annotations.json"
  ],
  "dm6": [
    "/resources/tracks/dm6_annotations.json"
  ],
  "ce11": [
    "/resources/tracks/ce11_annotations.json"
  ],
  "rn6": [
    "/resources/tracks/rn6_annotations.json"
  ]
}
